import Ravenia1 from '../Ravenia/Ravenia (1).webp'
import Ravenia2 from '../Ravenia/Ravenia (2).webp'
import Ravenia3 from '../Ravenia/Ravenia (3).webp'
import Ravenia4 from '../Ravenia/Ravenia (4).webp'
import Ravenia5 from '../Ravenia/Ravenia (5).webp'
import Ravenia6 from '../Ravenia/Ravenia (6).webp'



const Raveniaimages =[
Ravenia1,Ravenia2,Ravenia3,Ravenia4,Ravenia5,Ravenia6
]

export default Raveniaimages;